import { ToggleButton } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormFieldset } from 'src/shared/components/form/formFieldset';
import { StyledToggleButtonGroup } from 'src/shared/components/organisms/styledToggleButtonGroup';

type SwishConsentStatusesProps = {
  initialValue: string[];
  callback: (statuses: string[] | undefined) => void;
};

// Alla consent-statusar (råa strängvärden). Etiketterna översätts via swishStatus.consentStatusValues.*.
export const SWISH_CONSENT_STATUSES: string[] = ['CREATED', 'SIGNING', 'ACTIVE', 'PENDING', 'TIMEOUT', 'DECLINED', 'DELETED', 'REVOKED'];

// Flervalsfilter för Swish-medgivandestatus (speglar autogiroOverviewStatuses).
export const SwishConsentStatuses = (props: SwishConsentStatusesProps) => {
  const { initialValue, callback } = props;
  const { t } = useTranslation(['invoice']);

  const allStatuses = useMemo(() => SWISH_CONSENT_STATUSES, []);

  const initialStatuses = useMemo(() => {
    if (initialValue && initialValue.length) {
      return allStatuses.filter((s) => initialValue.includes(s));
    }
    return allStatuses;
  }, [allStatuses, initialValue]);

  const [selectedStatuses, setSelectedStatuses] = useState<string[]>(initialStatuses);

  useEffect(() => {
    const newStatuses = initialValue?.length ? allStatuses.filter((s) => initialValue.includes(s)) : allStatuses;
    setSelectedStatuses(newStatuses);
  }, [initialValue, allStatuses]);

  const handleStatuses = (event: React.MouseEvent<HTMLElement>, newStatuses: string[]) => {
    setSelectedStatuses(newStatuses);
    callback(newStatuses);
  };

  return (
    <FormFieldset legend={t('invoice:swishStatus.consents.status')} noPadding>
      <StyledToggleButtonGroup value={selectedStatuses} onChange={handleStatuses} color='primary' size='small'>
        {allStatuses.map((s) => (
          <ToggleButton value={s} key={s}>
            {t(`invoice:swishStatus.consentStatusValues.${s}`)}
          </ToggleButton>
        ))}
      </StyledToggleButtonGroup>
    </FormFieldset>
  );
};
